import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {I18NextPipe} from "@kokos-i18next";

@Component({
  selector: 'kokos-postfach-feedback',
  templateUrl: './postfach-feedback.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    I18NextPipe
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PostfachFeedbackComponent{}